<template>
  <b-container class="moreSheets" fluid>
    <div class="moreSheets__inner">
      <b-button
        variant="outline-success sm"
        class="moreSheets__add"
        @click="addSubsheet"
        >
        <icon name="plus" />
      </b-button>
      <div class="moreSheets__list">
        <b-button
          v-for="sheet in sheets"
          :key="sheet.key"
          :variant="isSheetBtnActive(sheet.key) ? 'secondary sm' : 'outline-secondary sm'"
          :disabled="isSheetBtnActive(sheet.key)"
          @click="setActiveSheet(sheet.key)"
          class="moreSheets__item"
          >
          <span
            :contenteditable="sheetToEdit === sheet.key && renameStarted"
            class="js-sheetTab"
            :data-sheet="sheet.key"
            @blur="finishRename"
            @keypress.enter.prevent="blurSheetNameInput"
            >{{ sheet.title }}</span>
          <keep-alive>
            <span
              v-if="activeSheet === sheet.key"
              class="moreSheets__editItem"
              @click.stop="showContextMenu($event, sheet.key)"
              >
              <icon name="sort-down" />
            </span>
          </keep-alive>
        </b-button>
      </div>
    </div>
    <ContextMenu
      :visible="isContextMenuVisible"
      :positionX="contextMenuPos.x"
      :positionY="contextMenuPos.y"
      @closeContextMenu="isContextMenuVisible = false"
      >
      <div>
        <b-list-group>
          <b-list-group-item
            href="#"
            @click.prevent="startRename"
            >
            Rename
          </b-list-group-item>
          <b-list-group-item
            v-if="$count(sheets) > 1"
            href="#"
            @click.prevent="deleteSheet">
            Delete
          </b-list-group-item>
        </b-list-group>
      </div>
    </ContextMenu>
    <NewSheetModal :parent-sheet="sheet" />
  </b-container>
</template>

<script>
// helpers
import db from '@/services/db'
import eventBus from '@/helpers/event-bus'
// components
import ContextMenu from '@/components/ContextMenu'
import NewSheetModal from '@/components/Modals/NewSheet'

let $ = window.$

export default {
  props: {
    sheet: { type: Object, required: true }
  },
  components: {
    ContextMenu,
    NewSheetModal
  },
  data () {
    return {
      sheets: [],
      activeSheet: this.sheet.activeSheet,
      subsheetRefKey: '',
      subsheetInput: false,
      createSubsheetInProgress: false,
      sheetToEdit: '',
      renameStarted: false,
      lastKnownTitle: '',
      isContextMenuVisible: false,
      contextMenuPos: {
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    isSheetBtnActive (sheet) {
      if (this.sheets.length > 1) {
        return sheet === this.activeSheet
      }
      return true
    },
    setActiveSheet (sheet) {
      db.sheets.setActive(sheet)
    },
    deleteSheet () {
      this.$store.commit('addProcess', {
        process: 'deleteSheet',
        message: 'Deleting'
      })
      db.sheets.delete(this.sheetToEdit, this.sheets, (err) => {
        this.$store.commit('deleteProcess', 'deleteSheet')
        this.sheetToEdit = ''
        if (err) this.$store.commit('addError', err.message)
      })
    },
    showContextMenu (event, key) {
      this.isContextMenuVisible = true
      this.contextMenuPos.x = event.pageX
      this.contextMenuPos.y = event.pageY
      this.sheetToEdit = key
    },
    startRename () {
      this.renameStarted = true
      let editable = $(`.js-sheetTab[data-sheet="${this.sheetToEdit}"]`)
      this.lastKnownTitle = editable.text()
      editable.focus()
      setTimeout(() => {
        this.$cursorToEnd(editable.get(0))
        this.isContextMenuVisible = false
      })
    },
    finishRename () {
      this.renameStarted = false
      let editable = $(`.js-sheetTab[data-sheet="${this.sheetToEdit}"]`)
      if (!editable.text()) editable.text(this.lastKnownTitle)
      this.lastKnownTitle = ''
      let newTitle = editable.text()
      let sheet = this.sheetToEdit

      if (!sheet || !newTitle) return

      this.$store.commit('addProcess', {
        process: 'renameSheet',
        message: 'Renaming'
      })

      db.sheets.rename(sheet, newTitle, (err) => {
        this.$store.commit('deleteProcess', 'renameSheet')
        if (err) this.$store.commit('addError', err.message)
      })
    },
    blurSheetNameInput () {
      $(`.js-sheetTab[data-sheet="${this.sheetToEdit}"]`).blur()
    },
    addSubsheet () {
      eventBus.$emit('addSubsheet')
    }
  },
  created () {
    // fill sheets property
    let vm = this
    let key = this.sheet.key
    let title = this.sheet.title
    if (!this.sheet.rootDeleted) {
      this.sheets.push({
        key: key,
        title: title || 'Sheet 1'
      })
    }
    let count = 1
    if (this.sheet.subsheets) {
      for (let subKey in this.sheet.subsheets) {
        let title = vm.sheet.subsheets[subKey].title
        this.sheets.push({
          key: key + '.' + subKey,
          title: title || 'Sheet ' + (++count)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.moreSheets {
  padding: {
    top: 20px;
    bottom: 20px;
  }
  &__inner {
    position: relative;
  }
  &__add {
    margin-right: 10px;
    svg {
      vertical-align: -3px;
    }
  }
  &__list {
    display: inline-block;
  }
  &__item {
    margin-right: 5px;
    &:hover .moreSheets__editItem {
      cursor: pointer;
      color: $color2;
    }
  }
  &__editItem svg {
    margin-top: -5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Spreadsheet/MoreSheets.vue